import { render, staticRenderFns } from "./ClearAlignerConsentForm.vue?vue&type=template&id=6ca82bee&scoped=true"
import script from "./ClearAlignerConsentForm.vue?vue&type=script&lang=js"
export * from "./ClearAlignerConsentForm.vue?vue&type=script&lang=js"
import style0 from "./ClearAlignerConsentForm.vue?vue&type=style&index=0&id=6ca82bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca82bee",
  null
  
)

export default component.exports